module.exports = __webpack_public_path__ + "img/WOOTEA.9c49502a.svg";